import { IAboutBusiness } from 'types';

export const businessInformation: IAboutBusiness = {
    businessDescription: 'This is a business description',
    businessStart: '2019-01-01',
};
